import { useEffect, useState } from "react";
import { useContractReads } from "wagmi";
import { _no, _notEmpty } from "../utils";
import { DEFAULT_DECIMALS, ERROR_NFTIDS, ERROR_TRANSACTION } from "../utils/config";
import { formatUnits, getAbiItem } from "viem";

const useGetFarmPositions = ({
    config,
    address,
    refetch,
    farms
}) => {

    const { chainId } = config;

    const enabled = _notEmpty(address)
        && _notEmpty(chainId)
        && farms.length
        && _no(farms.find(farm => _no(farm?.contractConfig?.address)));

    const [farmDatas, setFarmDatas] = useState(farms);
    const [doneFetchingNfts, setDoneFetchingNfts] = useState(
        _no(
            address
        )
    );
    const [doneFetchingTransactions, setDoneFetchingTransactions] = useState(
        _no(
            address
        )
    );

    const nftContracts = farms.map((farm) => {
        return {
            chainId,
            abi: [
                getAbiItem({
                    abi: farm?.contractConfig?.abi,
                    name: "reservedKeys",
                    type: "function"
                })
            ],
            address: farm?.contractConfig?.address,
            functionName: "reservedKeys",
            args: [address],
        };
    });

    const tokenContract = useContractReads({
        allowFailure: true,
        watch: false,
        enabled,
        contracts: nftContracts,
        onError: (error) => {
            console.error(
                ERROR_NFTIDS,
                error
            );
        },
        onSuccess: (data) => {
            setFarmDatas(farms.map((farm, i) => ({
                ...farm,
                farmNftId: data[i]?.result ?? -1
            })));
            setDoneFetchingNfts(true);
        }
    });

    const transactionEnabled = enabled
        && doneFetchingNfts;

    const transactionContracts = farmDatas?.map(farm => {
        return {
            chainId,
            abi: [
                getAbiItem({
                    abi: farm?.contractConfig?.abi,
                    name: "farmData",
                    type: "function"
                })
            ],
            address: farm?.contractConfig?.address,
            functionName: "farmData",
            args: [
                farm.farmNftId
            ],
        };
    });

    useContractReads({
        allowFailure: true,
        watch: false,
        enabled: transactionEnabled,
        contracts: transactionContracts,
        onError: (error) => {
            console.error(
                ERROR_TRANSACTION,
                chainId,
                error,
            );
        },
        onSuccess: (data) => {
            setFarmDatas(farmDatas.map((farm, i) => {
                if (data[i].result) {
                    const result = data[i].result;
                    const token = farm.token;
                    const wiseLendingNFT = formatUnits(
                        result[0],
                        0
                    );
                    const leverage = formatUnits(
                        result[1],
                        DEFAULT_DECIMALS
                    );

                    const amount = formatUnits(
                        result[2],
                        token.decimals
                    );

                    const amountAfterMintFee = formatUnits(
                        result[3],
                        token.decimals
                    );

                    const timestamp = result[4];

                    return {
                        ...farm,
                        transaction: {
                            wiseLendingNFT,
                            leverage,
                            amount,
                            amountAfterMintFee,
                            timestamp
                        }
                    };
                }

                return farm;
            }));
            setDoneFetchingTransactions(true);
        }
    });

    useEffect(() => {
        setFarmDatas(farms);
        setDoneFetchingNfts(
            _no(
                address
            )
        );
        setDoneFetchingTransactions(
            _no(
                address
            )
        );

        if (farms && tokenContract && enabled) {
            tokenContract.refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, refetch]);

    return {
        isFetching: _no(doneFetchingNfts && doneFetchingTransactions),
        enabled,
        farmDatas
    };
};

export default useGetFarmPositions;
